import React from 'react';
import { galleryItems } from '../data/galleryItems';
import '../styles/Gallery.css';

function GalleryCard({ item, index }) {
  const handleImageError = (e) => {
    e.target.style.display = 'none';
    e.target.nextSibling.style.display = 'flex';
  };

  return (
    <div 
      className="gallery-card"
      style={{ animationDelay: `${index * 150}ms` }}
    >
      <div className="gallery-card-header">
        <h3 className="gallery-card-title">{item.title}</h3>
        <p className="gallery-card-meta">
          <span className="gallery-cost">Total cost: {item.cost}</span>
          <span className="gallery-separator">|</span>
          <span className="gallery-time">Time: {item.time}</span>
        </p>
      </div>
      
      <div className="screenshot-container">
        <img
          src={item.screenshot}
          alt={`${item.title} website screenshot`}
          className="screenshot-image"
          onError={handleImageError}
        />
        <div className="screenshot-placeholder">
          <span className="placeholder-title">{item.title}</span>
          <span className="placeholder-subtitle">Screenshot coming soon</span>
        </div>
      </div>
      
      <a
        href={item.liveUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="gallery-link"
      >
        View Live <span className="link-arrow">→</span>
      </a>
    </div>
  );
}

function Gallery() {
  return (
    <div className="gallery-page">
      <div className="gallery-container">
        <header className="gallery-header">
          <h1 className="gallery-title">Stunning Sites</h1>
          <p className="gallery-subtitle">
            Shouldn't be out of reach. Here's some great examples to stir your imagination.
          </p>
        </header>
        
        <div className="gallery-grid">
          {galleryItems.map((item, index) => (
            <GalleryCard key={item.id} item={item} index={index} />
          ))}
        </div>
      </div>
    </div>
  );
}

export default Gallery;
